// extracted by mini-css-extract-plugin
module.exports = {"changePasswordDialog":"ChangePassword_changePasswordDialog__2rvSp"};